import React from 'react';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';

/**
 * Tanımsız adres — 404.
 *
 * Eskiden bu durumda boş bir ekran çiziliyordu; ziyaretçi sitenin bozulduğunu
 * sanıyordu. Yönetim paneli ayrı bir alan adına kilitlendiğinde ana sitedeki
 * ``/admin`` yolu da buraya düşer ve panelin varlığına dair hiçbir iz
 * bırakmaz: sayfa, olmayan herhangi bir adresle aynı yanıtı verir.
 */
const NotFound = () => (
  <main className="min-h-[60vh] grid place-items-center px-4 py-16">
    <section className="pusu-panel max-w-md w-full p-8 text-center flex flex-col items-center gap-4">
      <span
        className="w-14 h-14 rounded-2xl grid place-items-center"
        style={{ background: 'var(--pusu-card)', border: '1px solid var(--pusu-border)' }}
      >
        <Compass size={26} className="text-[var(--pusu-gold)]" aria-hidden="true" />
      </span>
      <div className="text-4xl font-black gold-text">404</div>
      <h1 className="text-lg font-bold">Sayfa bulunamadı</h1>
      <p className="text-sm text-gray-400">
        Aradığınız sayfa taşınmış ya da hiç var olmamış olabilir.
      </p>
      <Link to="/" className="gold-btn px-6 py-2.5 rounded-xl text-sm font-semibold">
        Ana sayfaya dön
      </Link>
    </section>
  </main>
);

export default NotFound;
